import { forEachNode, bindClickEvent, addCssClass, removeCssClass } from '@/shared'

export function renderTruncate () {
  const truncate = document.querySelectorAll('.js-truncate')

  forEachNode(truncate, item => {
    bindClickEvent(item, '.js-truncate-trigger', ({e}) => {
      e.preventDefault()
      e.stopPropagation()

      if (item.classList.contains('is-active')) {
        removeCssClass(item, 'is-active')
      } else {
        addCssClass(item, 'is-active')
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/modules/truncate.js